module.exports = __webpack_public_path__ + "static/media/origami2.b98c60a2.JPG";